var map = {
	"./ability_icons/Acid_Spray_icon.png": 92714,
	"./ability_icons/Acorn_Shot_icon.png": 94591,
	"./ability_icons/Activate_Fire_Remnant_icon.png": 12135,
	"./ability_icons/Adaptive_Strike_(Agility)_icon.png": 12375,
	"./ability_icons/Adaptive_Strike_(Strength)_icon.png": 77014,
	"./ability_icons/Adaptive_Strike_icon.png": 52718,
	"./ability_icons/Aegis_of_the_Immortal_ability_icon.png": 29467,
	"./ability_icons/Aether_Remnant_icon.png": 3836,
	"./ability_icons/Aftershock_icon.png": 14243,
	"./ability_icons/Aghanim's_Scepter_Synth_icon.png": 51818,
	"./ability_icons/Aghanim's_Shard_ability_icon.png": 81149,
	"./ability_icons/Alacrity_icon.png": 24935,
	"./ability_icons/Anchor_Smash_icon.png": 33872,
	"./ability_icons/Ancient_Seal_icon.png": 92144,
	"./ability_icons/Aphotic_Shield_icon.png": 20501,
	"./ability_icons/Arc_Lightning_icon.png": 80342,
	"./ability_icons/Arcane_Aura_icon.png": 7164,
	"./ability_icons/Arcane_Bolt_icon.png": 70222,
	"./ability_icons/Arcane_Curse_icon.png": 8848,
	"./ability_icons/Arcane_Orb_icon.png": 35174,
	"./ability_icons/Arcane_Rune_buff_icon.png": 6290,
	"./ability_icons/Arcane_Supremacy_icon.png": 69818,
	"./ability_icons/Arctic_Burn_icon.png": 80365,
	"./ability_icons/Arena_Of_Blood_icon.png": 89762,
	"./ability_icons/Armor_Corruption_icon.png": 11921,
	"./ability_icons/Assassinate_icon.png": 17807,
	"./ability_icons/Assimilate_icon.png": 81508,
	"./ability_icons/Astral_Imprisonment_icon.png": 6654,
	"./ability_icons/Astral_Spirit_icon.png": 87652,
	"./ability_icons/Astral_Step_icon.png": 55819,
	"./ability_icons/Atrophy_Aura_icon.png": 2353,
	"./ability_icons/Attribute_Shift_(Agility_Gain)_icon.png": 57967,
	"./ability_icons/Attribute_Shift_(Strength_Gain)_icon.png": 85853,
	"./ability_icons/Avalanche_icon.png": 9184,
	"./ability_icons/Bad_Juju_icon.png": 79848,
	"./ability_icons/Ball_Lightning_icon.png": 27407,
	"./ability_icons/Bash_of_the_Deep_icon.png": 41078,
	"./ability_icons/Battery_Assault_icon.png": 26931,
	"./ability_icons/Battle_Cry_icon.png": 69546,
	"./ability_icons/Battle_Hunger_icon.png": 37483,
	"./ability_icons/Battle_Trance_icon.png": 50068,
	"./ability_icons/Bedlam_icon.png": 35380,
	"./ability_icons/Berserk_Potion_icon.png": 93823,
	"./ability_icons/Berserker's_Blood_icon.png": 56836,
	"./ability_icons/Berserker's_Call_icon.png": 91592,
	"./ability_icons/Berserker's_Rage_(melee)_icon.png": 68707,
	"./ability_icons/Berserker's_Rage_icon.png": 33179,
	"./ability_icons/Black_Hole_icon.png": 11781,
	"./ability_icons/Blade_Dance_icon.png": 43058,
	"./ability_icons/Blade_Fury_icon.png": 86645,
	"./ability_icons/Blast_Off_icon.png": 71366,
	"./ability_icons/Blinding_Light_icon.png": 22565,
	"./ability_icons/Blink_(Anti-Mage)_icon.png": 97761,
	"./ability_icons/Blink_(Queen_of_Pain)_icon.png": 78239,
	"./ability_icons/Blink_Fragment_icon.png": 28467,
	"./ability_icons/Blink_Strike_icon.png": 83473,
	"./ability_icons/Blood_Rite_icon.png": 76801,
	"./ability_icons/Bloodlust_icon.png": 29882,
	"./ability_icons/Bloodrage_icon.png": 63027,
	"./ability_icons/Blur_icon.png": 47117,
	"./ability_icons/Borrowed_Time_icon.png": 86802,
	"./ability_icons/Boulder_Smash_icon.png": 29571,
	"./ability_icons/Boundless_Strike_icon.png": 52277,
	"./ability_icons/Brain_Sap_icon.png": 9554,
	"./ability_icons/Bramble_Maze_icon.png": 81000,
	"./ability_icons/Break_Tether_icon.png": 50752,
	"./ability_icons/Breathe_Fire_icon.png": 75701,
	"./ability_icons/Bristleback_icon.png": 12562,
	"./ability_icons/Bulldoze_icon.png": 54403,
	"./ability_icons/Bulwark_icon.png": 62590,
	"./ability_icons/Burning_Army_icon.png": 33867,
	"./ability_icons/Burning_Barrage_icon.png": 1652,
	"./ability_icons/Burning_Spear_icon.png": 29018,
	"./ability_icons/Burrow_icon.png": 48348,
	"./ability_icons/Burrowstrike_icon.png": 99996,
	"./ability_icons/Bushwhack_icon.png": 68485,
	"./ability_icons/Buyback_gold_penalty_icon.png": 34396,
	"./ability_icons/Buyback_icon.png": 50170,
	"./ability_icons/Buyback_used_icon.png": 61297,
	"./ability_icons/Call_Down_icon.png": 12620,
	"./ability_icons/Call_of_the_Wild_Boar_icon.png": 95026,
	"./ability_icons/Call_of_the_Wild_Hawk_icon.png": 2784,
	"./ability_icons/Cancel_Dark_Rift_icon.png": 51473,
	"./ability_icons/Caustic_Finale_icon.png": 45265,
	"./ability_icons/Celestial_Hammer_icon.png": 22002,
	"./ability_icons/Chain_Frost_icon.png": 67554,
	"./ability_icons/Chakra_Magic_icon.png": 18824,
	"./ability_icons/Chakram_icon.png": 88699,
	"./ability_icons/Chaos_Bolt_icon.png": 97971,
	"./ability_icons/Chaos_Meteor_icon.png": 68091,
	"./ability_icons/Chaos_Strike_icon.png": 36745,
	"./ability_icons/Chaotic_Offering_icon.png": 34372,
	"./ability_icons/Charge_of_Darkness_icon.png": 83897,
	"./ability_icons/Chemical_Rage_icon.png": 76642,
	"./ability_icons/Chilling_Touch_icon.png": 13362,
	"./ability_icons/Chronosphere_icon.png": 4334,
	"./ability_icons/Cinder_Brew_icon.png": 51485,
	"./ability_icons/Cloak_and_Dagger_icon.png": 61837,
	"./ability_icons/Cold_Blooded_icon.png": 76787,
	"./ability_icons/Cold_Embrace_icon.png": 68224,
	"./ability_icons/Cold_Feet_icon.png": 38936,
	"./ability_icons/Cold_Snap_icon.png": 55856,
	"./ability_icons/Concussive_Grenade_icon.png": 77912,
	"./ability_icons/Concussive_Shot_icon.png": 9590,
	"./ability_icons/Conjure_Image_icon.png": 45333,
	"./ability_icons/Consume_icon.png": 68080,
	"./ability_icons/Control_icon.png": 7691,
	"./ability_icons/Converge_icon.png": 58373,
	"./ability_icons/Corrosive_Haze_icon.png": 77205,
	"./ability_icons/Corrosive_Skin_icon.png": 22338,
	"./ability_icons/Counter_Helix_icon.png": 6418,
	"./ability_icons/Counterspell_icon.png": 74836,
	"./ability_icons/Coup_de_Grace_icon.png": 45898,
	"./ability_icons/Craggy_Exterior_icon.png": 13511,
	"./ability_icons/Crippling_Fear_icon.png": 63600,
	"./ability_icons/Crypt_Swarm_icon.png": 67343,
	"./ability_icons/Crystal_Nova_icon.png": 84497,
	"./ability_icons/Culling_Blade_icon.png": 69962,
	"./ability_icons/Curse_of_Avernus_icon.png": 40813,
	"./ability_icons/Cursed_Crown_icon.png": 14026,
	"./ability_icons/Dark_Ascension_icon.png": 42001,
	"./ability_icons/Dark_Pact_icon.png": 8034,
	"./ability_icons/Dark_Portrait_icon.png": 33535,
	"./ability_icons/Dark_Rift_icon.png": 59090,
	"./ability_icons/Darkness_icon.png": 14821,
	"./ability_icons/Deafening_Blast_icon.png": 92374,
	"./ability_icons/Death_Pact_icon.png": 33259,
	"./ability_icons/Death_Pulse_icon.png": 79160,
	"./ability_icons/Death_Seeker_icon.png": 75824,
	"./ability_icons/Death_Ward_icon.png": 11112,
	"./ability_icons/Decay_icon.png": 46308,
	"./ability_icons/Decoy_icon.png": 92407,
	"./ability_icons/Decrepify_icon.png": 93213,
	"./ability_icons/Defense_Matrix_icon.png": 27704,
	"./ability_icons/Degen_Aura_icon.png": 98406,
	"./ability_icons/Demon_Zeal_icon.png": 64995,
	"./ability_icons/Demonic_Cleanse_icon.png": 45101,
	"./ability_icons/Demonic_Conversion_icon.png": 39099,
	"./ability_icons/Demonic_Purge_icon.png": 98917,
	"./ability_icons/Depth_Shroud_icon.png": 10770,
	"./ability_icons/Desolate_icon.png": 19945,
	"./ability_icons/Devour_icon.png": 23420,
	"./ability_icons/Diabolic_Edict_icon.png": 85261,
	"./ability_icons/Dig_icon.png": 64122,
	"./ability_icons/Dismember_icon.png": 70517,
	"./ability_icons/Dispersion_icon.png": 59983,
	"./ability_icons/Dispose_icon.png": 97381,
	"./ability_icons/Disruption_icon.png": 84263,
	"./ability_icons/Dissimilate_icon.png": 8038,
	"./ability_icons/Divided_We_Stand_icon.png": 96030,
	"./ability_icons/Divine_Favor_icon.png": 68513,
	"./ability_icons/Divine_Sanction_icon.png": 49174,
	"./ability_icons/Doom_ability_icon.png": 68021,
	"./ability_icons/Doppelganger_icon.png": 26700,
	"./ability_icons/Double_Damage_Rune_buff_icon.png": 33982,
	"./ability_icons/Double_Edge_icon.png": 5322,
	"./ability_icons/Dragon_Blood_icon.png": 98520,
	"./ability_icons/Dragon_Slave_icon.png": 54296,
	"./ability_icons/Dragon_Tail_icon.png": 45025,
	"./ability_icons/Dream_Coil_icon.png": 25285,
	"./ability_icons/Druid_Form_icon.png": 31295,
	"./ability_icons/Drunken_Brawler_(Earth)_icon.png": 90876,
	"./ability_icons/Drunken_Brawler_(Fire)_icon.png": 9915,
	"./ability_icons/Drunken_Brawler_(Storm)_icon.png": 9929,
	"./ability_icons/Drunken_Brawler_(Void)_icon.png": 84581,
	"./ability_icons/Drunken_Brawler_both_icon.png": 89561,
	"./ability_icons/Drunken_Brawler_crit_icon.png": 19615,
	"./ability_icons/Drunken_Brawler_icon.png": 53054,
	"./ability_icons/Drunken_Brawler_miss_icon.png": 81654,
	"./ability_icons/Dual_Breath_icon.png": 27252,
	"./ability_icons/Duel_icon.png": 87765,
	"./ability_icons/EMP_icon.png": 16458,
	"./ability_icons/Earth_Spike_icon.png": 91098,
	"./ability_icons/Earth_Splitter_icon.png": 88568,
	"./ability_icons/Earthbind_icon.png": 89636,
	"./ability_icons/Earthshock_icon.png": 91251,
	"./ability_icons/Echo_Slam_icon.png": 23955,
	"./ability_icons/Echo_Stomp_icon.png": 75917,
	"./ability_icons/Eclipse_icon.png": 84413,
	"./ability_icons/Eject_(Lifestealer)_icon.png": 57069,
	"./ability_icons/Elder_Dragon_Form_icon.png": 49196,
	"./ability_icons/Electric_Rave_icon.png": 69145,
	"./ability_icons/Electric_Vortex_icon.png": 80587,
	"./ability_icons/Empower_icon.png": 75715,
	"./ability_icons/Empowering_Haste_icon.png": 88423,
	"./ability_icons/Enchant_Remnant_icon.png": 87435,
	"./ability_icons/Enchant_Totem_icon.png": 24294,
	"./ability_icons/Enchant_icon.png": 44577,
	"./ability_icons/End_Roll_Up_icon.png": 619,
	"./ability_icons/End_Sharpshooter_icon.png": 76533,
	"./ability_icons/Enfeeble_icon.png": 56173,
	"./ability_icons/Enrage_icon.png": 31867,
	"./ability_icons/Ensnare_icon.png": 54978,
	"./ability_icons/Epicenter_icon.png": 18277,
	"./ability_icons/Essence_Flux_icon.png": 15755,
	"./ability_icons/Essence_Shift_icon.png": 64458,
	"./ability_icons/Ether_Shock_icon.png": 49132,
	"./ability_icons/Ethereal_Jaunt_icon.png": 41738,
	"./ability_icons/Exorcism_icon.png": 26814,
	"./ability_icons/Exort_icon.png": 30015,
	"./ability_icons/Eye_of_the_Storm_icon.png": 76131,
	"./ability_icons/Eyes_in_the_Forest_icon.png": 86647,
	"./ability_icons/Fade_Bolt_icon.png": 28846,
	"./ability_icons/False_Promise_icon.png": 35067,
	"./ability_icons/Fan_of_Knives_icon.png": 21487,
	"./ability_icons/Fatal_Bonds_icon.png": 92691,
	"./ability_icons/Fate's_Edict_icon.png": 57261,
	"./ability_icons/Feast_icon.png": 34547,
	"./ability_icons/Feral_Impulse_icon.png": 93272,
	"./ability_icons/Fervor_icon.png": 11418,
	"./ability_icons/Fiend's_Gate_icon.png": 16081,
	"./ability_icons/Fiend's_Grip_icon.png": 26049,
	"./ability_icons/Fiery_Soul_icon.png": 13024,
	"./ability_icons/Finger_of_Death_icon.png": 40553,
	"./ability_icons/Fire_Remnant_icon.png": 58190,
	"./ability_icons/Fire_Shield_icon.png": 19338,
	"./ability_icons/Fire_Spirits_icon.png": 21586,
	"./ability_icons/Fireball_icon.png": 35154,
	"./ability_icons/Fireblast_icon.png": 46437,
	"./ability_icons/Firefly_icon.png": 86128,
	"./ability_icons/Firesnap_Cookie_icon.png": 70827,
	"./ability_icons/Firestorm_icon.png": 51060,
	"./ability_icons/Fish_Bait_icon.png": 32784,
	"./ability_icons/Fissure_icon.png": 87157,
	"./ability_icons/Flak_Cannon_icon.png": 9330,
	"./ability_icons/Flak_Cannon_overhead_icon.png": 83745,
	"./ability_icons/Flame_Guard_icon.png": 68586,
	"./ability_icons/Flamebreak_icon.png": 94584,
	"./ability_icons/Flamethrower_icon.png": 56390,
	"./ability_icons/Flaming_Lasso_icon.png": 72843,
	"./ability_icons/Flesh_Golem_icon.png": 63976,
	"./ability_icons/Flesh_Heap_icon.png": 25865,
	"./ability_icons/Flux_icon.png": 47811,
	"./ability_icons/Focus_Fire_icon.png": 35448,
	"./ability_icons/Focused_Detonate_icon.png": 26199,
	"./ability_icons/Forge_Spirit_icon.png": 96492,
	"./ability_icons/Fortune's_End_icon.png": 37854,
	"./ability_icons/Freezing_Field_icon.png": 75471,
	"./ability_icons/Frost_Arrows_icon.png": 36631,
	"./ability_icons/Frost_Aura_icon.png": 31678,
	"./ability_icons/Frost_Blast_icon.png": 16187,
	"./ability_icons/Frost_Shield_icon.png": 76916,
	"./ability_icons/Frostbite_icon.png": 34425,
	"./ability_icons/Frozen_Sigil_icon.png": 74832,
	"./ability_icons/Fury_Swipes_icon.png": 7923,
	"./ability_icons/Gale_Force_icon.png": 26157,
	"./ability_icons/Geminate_Attack_icon.png": 52545,
	"./ability_icons/Geomagnetic_Grip_icon.png": 66713,
	"./ability_icons/Geostrike_icon.png": 47594,
	"./ability_icons/Ghost_Shroud_icon.png": 86478,
	"./ability_icons/Ghost_Walk_icon.png": 51099,
	"./ability_icons/Ghostship_icon.png": 90923,
	"./ability_icons/Ghoul_Frenzy_icon.png": 3620,
	"./ability_icons/Glaives_of_Wisdom_icon.png": 60116,
	"./ability_icons/Glimpse_icon.png": 14704,
	"./ability_icons/Global_Silence_icon.png": 5839,
	"./ability_icons/Glyph_of_Fortification_icon.png": 25938,
	"./ability_icons/Glyph_of_Fortification_off_icon.png": 70428,
	"./ability_icons/Gobble_Up_icon.png": 29037,
	"./ability_icons/God's_Rebuke_icon.png": 30048,
	"./ability_icons/God's_Strength_icon.png": 2482,
	"./ability_icons/Good_Juju_icon.png": 54454,
	"./ability_icons/Grave_Chill_icon.png": 79730,
	"./ability_icons/Gravekeeper's_Cloak_icon.png": 97620,
	"./ability_icons/Great_Cleave_icon.png": 76231,
	"./ability_icons/Greater_Bash_icon.png": 42626,
	"./ability_icons/Greevil's_Greed_icon.png": 75632,
	"./ability_icons/Grow_icon.png": 98811,
	"./ability_icons/Guardian_Angel_icon.png": 34852,
	"./ability_icons/Guardian_Sprint_icon.png": 80179,
	"./ability_icons/Gush_icon.png": 89930,
	"./ability_icons/Gust_icon.png": 45012,
	"./ability_icons/Hairball_icon.png": 46260,
	"./ability_icons/Hammer_of_Purity_icon.png": 47456,
	"./ability_icons/Hand_of_God_icon.png": 6230,
	"./ability_icons/Haste_Rune_buff_icon.png": 92486,
	"./ability_icons/Haunt_icon.png": 26254,
	"./ability_icons/Headshot_icon.png": 53026,
	"./ability_icons/Healing_Ward_icon.png": 21214,
	"./ability_icons/Heartpiercer_icon.png": 97451,
	"./ability_icons/Heartstopper_Aura_icon.png": 25711,
	"./ability_icons/Heat-Seeking_Missile_icon.png": 70762,
	"./ability_icons/Heavenly_Grace_icon.png": 29029,
	"./ability_icons/Heavenly_Jump_icon.png": 6988,
	"./ability_icons/Hex_(Lion)_icon.png": 5428,
	"./ability_icons/Hex_(Shadow_Shaman)_icon.png": 26036,
	"./ability_icons/Holy_Persuasion_icon.png": 98679,
	"./ability_icons/Homing_Missile_icon.png": 46494,
	"./ability_icons/Hoof_Stomp_icon.png": 43852,
	"./ability_icons/Hookshot_icon.png": 92174,
	"./ability_icons/Horn_Toss_icon.png": 54565,
	"./ability_icons/Howl_icon.png": 90569,
	"./ability_icons/Hunter's_Boomerang_icon.png": 80441,
	"./ability_icons/Hunter_in_the_Night_icon.png": 43966,
	"./ability_icons/Hybrid_icon.png": 55168,
	"./ability_icons/Icarus_Dive_icon.png": 94705,
	"./ability_icons/Ice_Armor_icon.png": 65240,
	"./ability_icons/Ice_Blast_icon.png": 12839,
	"./ability_icons/Ice_Path_icon.png": 95656,
	"./ability_icons/Ice_Shards_icon.png": 96919,
	"./ability_icons/Ice_Spire_icon.png": 52464,
	"./ability_icons/Ice_Vortex_icon.png": 44215,
	"./ability_icons/Ice_Wall_icon.png": 80227,
	"./ability_icons/Ignite_icon.png": 94297,
	"./ability_icons/Illuminate_(Spirit_Form)_icon.png": 57860,
	"./ability_icons/Illuminate_icon.png": 80362,
	"./ability_icons/Illusion_icon.png": 8507,
	"./ability_icons/Illusory_Orb_icon.png": 40100,
	"./ability_icons/Impale_icon.png": 23682,
	"./ability_icons/Impetus_icon.png": 11875,
	"./ability_icons/Incapacitating_Bite_icon.png": 51732,
	"./ability_icons/Infernal_Blade_icon.png": 78704,
	"./ability_icons/Infest_icon.png": 14930,
	"./ability_icons/Ink_Over_icon.png": 48775,
	"./ability_icons/Ink_Swell_icon.png": 93286,
	"./ability_icons/Inner_Beast_icon.png": 83644,
	"./ability_icons/Inner_Fire_icon.png": 66830,
	"./ability_icons/Inner_Vitality_icon.png": 8683,
	"./ability_icons/Insatiable_Hunger_icon.png": 94875,
	"./ability_icons/Invisibility_Rune_buff_icon.png": 4458,
	"./ability_icons/Invoke_icon.png": 91923,
	"./ability_icons/Invulnerability_icon.png": 92931,
	"./ability_icons/Ion_Shell_icon.png": 16938,
	"./ability_icons/Jetpack_icon.png": 30186,
	"./ability_icons/Jinada_icon.png": 90971,
	"./ability_icons/Jingu_Mastery_icon.png": 15045,
	"./ability_icons/Juxtapose_icon.png": 95685,
	"./ability_icons/Keen_Conveyance_icon.png": 60050,
	"./ability_icons/Kinetic_Field_icon.png": 4361,
	"./ability_icons/Kraken_Shell_icon.png": 50098,
	"./ability_icons/Laguna_Blade_icon.png": 14476,
	"./ability_icons/Laser_icon.png": 34764,
	"./ability_icons/Last_Word_icon.png": 22485,
	"./ability_icons/Launch_Fire_Spirit_icon.png": 41096,
	"./ability_icons/Launch_Snowball_icon.png": 25405,
	"./ability_icons/Leap_icon.png": 45736,
	"./ability_icons/Leech_Seed_icon.png": 17625,
	"./ability_icons/Life_Break_icon.png": 42515,
	"./ability_icons/Life_Drain_icon.png": 10618,
	"./ability_icons/Light_Strike_Array_icon.png": 15841,
	"./ability_icons/Lightning_Bolt_icon.png": 23223,
	"./ability_icons/Lightning_Storm_icon.png": 86613,
	"./ability_icons/Lil'_Shredder_icon.png": 22298,
	"./ability_icons/Linken's_Sphere_ability_icon.png": 82192,
	"./ability_icons/Liquid_Fire_icon.png": 60646,
	"./ability_icons/Liquid_Frost_icon.png": 52758,
	"./ability_icons/Living_Armor_icon.png": 88955,
	"./ability_icons/Lucent_Beam_icon.png": 54374,
	"./ability_icons/Lucky_Shot_icon.png": 35252,
	"./ability_icons/Luminosity_icon.png": 36011,
	"./ability_icons/Lunar_Blessing_icon.png": 35788,
	"./ability_icons/Macropyre_icon.png": 54585,
	"./ability_icons/Magic_Missile_icon.png": 47612,
	"./ability_icons/Magnetic_Field_icon.png": 24160,
	"./ability_icons/Magnetize_icon.png": 22364,
	"./ability_icons/Maledict_icon.png": 39799,
	"./ability_icons/Malefice_icon.png": 19810,
	"./ability_icons/Mana_Break_icon.png": 80605,
	"./ability_icons/Mana_Burn_icon.png": 99157,
	"./ability_icons/Mana_Drain_icon.png": 13775,
	"./ability_icons/Mana_Leak_icon.png": 39952,
	"./ability_icons/Mana_Shield_icon.png": 74466,
	"./ability_icons/Mana_Void_icon.png": 57125,
	"./ability_icons/March_of_the_Machines_icon.png": 3069,
	"./ability_icons/Marksmanship_icon.png": 77991,
	"./ability_icons/Mass_Serpent_Ward_icon.png": 41071,
	"./ability_icons/Meat_Hook_icon.png": 66929,
	"./ability_icons/Meld_icon.png": 99025,
	"./ability_icons/Metamorphosis_icon.png": 27241,
	"./ability_icons/Midnight_Pulse_icon.png": 95779,
	"./ability_icons/Minefield_Sign_icon.png": 88490,
	"./ability_icons/Mirror_Image_icon.png": 70377,
	"./ability_icons/Mischief_icon.png": 91014,
	"./ability_icons/Mist_Coil_icon.png": 27447,
	"./ability_icons/Moment_of_Courage_icon.png": 78,
	"./ability_icons/Moon_Glaives_icon.png": 21297,
	"./ability_icons/Moonlight_Shadow_icon.png": 54569,
	"./ability_icons/Morph_Replicate_icon.png": 97821,
	"./ability_icons/Morph_icon.png": 29387,
	"./ability_icons/Mortal_Strike_icon.png": 91324,
	"./ability_icons/Mortimer_Kisses_icon.png": 27607,
	"./ability_icons/Move_Astral_Spirit_icon.png": 63572,
	"./ability_icons/Multicast_icon.png": 68275,
	"./ability_icons/Multishot_icon.png": 3197,
	"./ability_icons/Mystic_Flare_icon.png": 6767,
	"./ability_icons/Mystic_Snake_icon.png": 51447,
	"./ability_icons/Natural_Order_icon.png": 65474,
	"./ability_icons/Nature's_Attendants_icon.png": 52967,
	"./ability_icons/Nature's_Call_icon.png": 63064,
	"./ability_icons/Nature's_Grasp_icon.png": 69865,
	"./ability_icons/Nature's_Guise_icon.png": 65367,
	"./ability_icons/Necromastery_icon.png": 99186,
	"./ability_icons/Nether_Blast_icon.png": 57882,
	"./ability_icons/Nether_Strike_icon.png": 30810,
	"./ability_icons/Nether_Swap_icon.png": 38886,
	"./ability_icons/Nether_Ward_icon.png": 50111,
	"./ability_icons/Nethertoxin_icon.png": 92798,
	"./ability_icons/Nightmare_End_icon.png": 19558,
	"./ability_icons/Nightmare_icon.png": 26150,
	"./ability_icons/Nihilism_icon.png": 29448,
	"./ability_icons/Nimbus_icon.png": 76772,
	"./ability_icons/Normal_Punch_icon.png": 48682,
	"./ability_icons/Null_Field_(Offensive)_icon.png": 19794,
	"./ability_icons/Omnislash_icon.png": 74700,
	"./ability_icons/Onslaught_icon.png": 76872,
	"./ability_icons/Open_Wounds_icon.png": 22252,
	"./ability_icons/Overcharge_icon.png": 53221,
	"./ability_icons/Overclocking_icon.png": 55253,
	"./ability_icons/Overgrowth_icon.png": 59029,
	"./ability_icons/Overload_icon.png": 80924,
	"./ability_icons/Overpower_icon.png": 83376,
	"./ability_icons/Overwhelming_Odds_icon.png": 37530,
	"./ability_icons/Paralyzing_Cask_icon.png": 44329,
	"./ability_icons/Penitence_icon.png": 69545,
	"./ability_icons/Phantasm_icon.png": 25549,
	"./ability_icons/Phantom's_Embrace_icon.png": 69346,
	"./ability_icons/Phantom_Rush_icon.png": 29391,
	"./ability_icons/Phantom_Strike_icon.png": 26619,
	"./ability_icons/Phase_Shift_icon.png": 78043,
	"./ability_icons/Pit_of_Malice_icon.png": 88054,
	"./ability_icons/Plague_Ward_icon.png": 75349,
	"./ability_icons/Plasma_Field_icon.png": 61160,
	"./ability_icons/Poison_Attack_icon.png": 65374,
	"./ability_icons/Poison_Nova_icon.png": 97210,
	"./ability_icons/Poison_Sting_icon.png": 47521,
	"./ability_icons/Poison_Touch_icon.png": 80919,
	"./ability_icons/Poof_icon.png": 97894,
	"./ability_icons/Pounce_icon.png": 28791,
	"./ability_icons/Power_Cogs_icon.png": 92050,
	"./ability_icons/Powershot_icon.png": 61496,
	"./ability_icons/Precision_Aura_icon.png": 23795,
	"./ability_icons/Presence_of_the_Dark_Lord_icon.png": 16620,
	"./ability_icons/Press_the_Attack_icon.png": 67599,
	"./ability_icons/Primal_Roar_icon.png": 89239,
	"./ability_icons/Primal_Split_Cancel_icon.png": 3894,
	"./ability_icons/Primal_Split_icon.png": 22294,
	"./ability_icons/Primal_Spring_icon.png": 89809,
	"./ability_icons/Proximity_Mines_icon.png": 99839,
	"./ability_icons/Psi_Blades_icon.png": 13130,
	"./ability_icons/Psionic_Projection_icon.png": 4765,
	"./ability_icons/Psionic_Trap_icon.png": 58745,
	"./ability_icons/Pulse_Nova_icon.png": 40264,
	"./ability_icons/Pulverize_icon.png": 43113,
	"./ability_icons/Purification_icon.png": 64297,
	"./ability_icons/Purifying_Flames_icon.png": 28825,
	"./ability_icons/Quas_icon.png": 61278,
	"./ability_icons/Quill_Spray_icon.png": 79498,
	"./ability_icons/Rabid_icon.png": 71585,
	"./ability_icons/Rage_icon.png": 75960,
	"./ability_icons/Rampage_icon.png": 94592,
	"./ability_icons/Ransack_icon.png": 41417,
	"./ability_icons/Ravage_icon.png": 79437,
	"./ability_icons/Reactive_Armor_icon.png": 39770,
	"./ability_icons/Reactive_Tazer_icon.png": 90074,
	"./ability_icons/Reality_Rift_icon.png": 31436,
	"./ability_icons/Reality_icon.png": 75134,
	"./ability_icons/Reaper's_Scythe_icon.png": 3815,
	"./ability_icons/Rearm_icon.png": 5383,
	"./ability_icons/Rebound_icon.png": 57166,
	"./ability_icons/Recall_icon.png": 41116,
	"./ability_icons/Reflection_icon.png": 79475,
	"./ability_icons/Refraction_icon.png": 85168,
	"./ability_icons/Regeneration_Rune_buff_icon.png": 68665,
	"./ability_icons/Reincarnation_icon.png": 52880,
	"./ability_icons/Release_Illuminate_(Spirit_Form)_icon.png": 64468,
	"./ability_icons/Release_Illuminate_icon.png": 48468,
	"./ability_icons/Release_icon.png": 47741,
	"./ability_icons/Relocate_icon.png": 41842,
	"./ability_icons/Remote_Mines_icon.png": 64956,
	"./ability_icons/Requiem_of_Souls_icon.png": 72197,
	"./ability_icons/Resonant_Pulse_icon.png": 44551,
	"./ability_icons/Retaliate_icon.png": 253,
	"./ability_icons/Return_(Kunkka)_icon.png": 47302,
	"./ability_icons/Return_Astral_Spirit_icon.png": 96969,
	"./ability_icons/Return_Chakram_icon.png": 78173,
	"./ability_icons/Return_Second_Chakram_icon.png": 94092,
	"./ability_icons/Reverse_Polarity_icon.png": 8427,
	"./ability_icons/Reverse_Time_Walk_icon.png": 56167,
	"./ability_icons/Revert_Form_icon.png": 93358,
	"./ability_icons/Rip_Tide_icon.png": 27935,
	"./ability_icons/Rock_Throw_icon.png": 90439,
	"./ability_icons/Rocket_Barrage_icon.png": 13667,
	"./ability_icons/Rocket_Flare_icon.png": 57024,
	"./ability_icons/Roll_Up_icon.png": 20229,
	"./ability_icons/Rolling_Boulder_icon.png": 42480,
	"./ability_icons/Rolling_Thunder_icon.png": 22874,
	"./ability_icons/Rot_icon.png": 92376,
	"./ability_icons/Rune_Forge_icon.png": 74619,
	"./ability_icons/Rupture_icon.png": 95757,
	"./ability_icons/Sacred_Arrow_icon.png": 51113,
	"./ability_icons/Sacrifice_icon.png": 29962,
	"./ability_icons/Sadist_icon.png": 85094,
	"./ability_icons/Sand_Storm_icon.png": 89014,
	"./ability_icons/Sanity's_Eclipse_icon.png": 29593,
	"./ability_icons/Savage_Roar_icon.png": 8926,
	"./ability_icons/Scan_icon.png": 88697,
	"./ability_icons/Scatterblast_icon.png": 65777,
	"./ability_icons/Scorched_Earth_icon.png": 24519,
	"./ability_icons/Scream_of_Pain_icon.png": 30084,
	"./ability_icons/Scurry_icon.png": 51193,
	"./ability_icons/Searing_Arrows_icon.png": 51636,
	"./ability_icons/Searing_Chains_icon.png": 94671,
	"./ability_icons/Second_Chakram_icon.png": 48721,
	"./ability_icons/Shackles_icon.png": 72355,
	"./ability_icons/Shackleshot_icon.png": 34428,
	"./ability_icons/Shadow_Dance_icon.png": 62259,
	"./ability_icons/Shadow_Poison_Release_icon.png": 85115,
	"./ability_icons/Shadow_Poison_icon.png": 92772,
	"./ability_icons/Shadow_Realm_icon.png": 6819,
	"./ability_icons/Shadow_Step_icon.png": 80528,
	"./ability_icons/Shadow_Strike_icon.png": 45979,
	"./ability_icons/Shadow_Walk_icon.png": 82160,
	"./ability_icons/Shadow_Wave_icon.png": 17342,
	"./ability_icons/Shadow_Word_icon.png": 10657,
	"./ability_icons/Shadowraze_(Far)_icon.png": 58696,
	"./ability_icons/Shadowraze_(Medium)_icon.png": 55506,
	"./ability_icons/Shadowraze_(Near)_icon copy.png": 8194,
	"./ability_icons/Shadowraze_icon.png": 97334,
	"./ability_icons/Shallow_Grave_icon.png": 84459,
	"./ability_icons/Shapeshift_icon.png": 97764,
	"./ability_icons/Sharpshooter_icon.png": 80037,
	"./ability_icons/Shield_Crash_icon.png": 85053,
	"./ability_icons/Shield_of_the_Scion_icon.png": 87147,
	"./ability_icons/Shockwave_icon.png": 53598,
	"./ability_icons/Shrapnel_icon.png": 45373,
	"./ability_icons/Shukuchi_icon.png": 27960,
	"./ability_icons/Shuriken_Toss_icon.png": 73673,
	"./ability_icons/Sidekick_icon.png": 49245,
	"./ability_icons/Silence_icon.png": 28156,
	"./ability_icons/Silent_as_the_Grave_icon.png": 55339,
	"./ability_icons/Silken_Bola_icon.png": 13252,
	"./ability_icons/Sinister_Gaze_icon.png": 53053,
	"./ability_icons/Skeleton_Walk_icon.png": 36769,
	"./ability_icons/Skewer_icon.png": 80396,
	"./ability_icons/Sleeping_Dart_icon.png": 85189,
	"./ability_icons/Sleight_of_Fist_icon.png": 77447,
	"./ability_icons/Slithereen_Crush_icon.png": 96945,
	"./ability_icons/Smoke_Screen_icon.png": 47350,
	"./ability_icons/Snowball_icon.png": 96406,
	"./ability_icons/Solar_Bind_icon.png": 48488,
	"./ability_icons/Solar_Guardian_Land_icon.png": 21452,
	"./ability_icons/Solar_Guardian_icon.png": 67565,
	"./ability_icons/Song_of_the_Siren_End_icon.png": 81383,
	"./ability_icons/Song_of_the_Siren_icon.png": 16037,
	"./ability_icons/Sonic_Wave_icon.png": 99445,
	"./ability_icons/Soul_Assumption_icon.png": 45972,
	"./ability_icons/Soul_Catcher_icon.png": 88365,
	"./ability_icons/Soul_Rip_icon.png": 74572,
	"./ability_icons/Soulbind_icon.png": 98198,
	"./ability_icons/Spark_Wraith_icon.png": 95050,
	"./ability_icons/Spawn_Spiderlings_icon.png": 3039,
	"./ability_icons/Spear_of_Mars_icon.png": 65577,
	"./ability_icons/Spectral_Dagger_icon.png": 94880,
	"./ability_icons/Spell_Immunity_icon.png": 35169,
	"./ability_icons/Spell_Immunity_old_icon.png": 97763,
	"./ability_icons/Spell_Steal_icon.png": 77163,
	"./ability_icons/Spiked_Carapace_icon.png": 14034,
	"./ability_icons/Spin_Web_icon.png": 76074,
	"./ability_icons/Spinner's_Snare_icon.png": 5909,
	"./ability_icons/Spirit_Form_icon.png": 90268,
	"./ability_icons/Spirit_Lance_icon.png": 38203,
	"./ability_icons/Spirit_Link_icon.png": 3429,
	"./ability_icons/Spirit_Siphon_icon.png": 77315,
	"./ability_icons/Spirits_Movement_icon.png": 65633,
	"./ability_icons/Spirits_Out_icon.png": 64119,
	"./ability_icons/Spirits_icon.png": 25787,
	"./ability_icons/Spit_Out_icon.png": 80800,
	"./ability_icons/Splinter_Blast_icon.png": 47984,
	"./ability_icons/Split_Earth_icon.png": 63174,
	"./ability_icons/Split_Shot_icon.png": 50324,
	"./ability_icons/Spring_Early_icon.png": 37731,
	"./ability_icons/Sproink_icon.png": 95022,
	"./ability_icons/Sprout_icon.png": 50883,
	"./ability_icons/Stampede_icon.png": 14305,
	"./ability_icons/Starbreaker_icon.png": 90651,
	"./ability_icons/Starstorm_icon.png": 30445,
	"./ability_icons/Stasis_Trap_icon.png": 90652,
	"./ability_icons/Static_Field_icon.png": 20882,
	"./ability_icons/Static_Link_icon.png": 82767,
	"./ability_icons/Static_Remnant_icon.png": 44089,
	"./ability_icons/Static_Storm_icon.png": 48879,
	"./ability_icons/Sticky_Bomb_icon.png": 75392,
	"./ability_icons/Sticky_Napalm_icon.png": 82203,
	"./ability_icons/Stifling_Dagger_icon.png": 90784,
	"./ability_icons/Stone_Form_icon.png": 76500,
	"./ability_icons/Stone_Gaze_icon.png": 19712,
	"./ability_icons/Stone_Remnant_icon.png": 15039,
	"./ability_icons/Stop_Freezing_Field_icon.png": 23085,
	"./ability_icons/Stop_Icarus_Dive_icon.png": 23583,
	"./ability_icons/Stop_Rolling_icon.png": 69332,
	"./ability_icons/Stop_Sun_Ray_icon.png": 96776,
	"./ability_icons/Storm_Hammer_icon.png": 73157,
	"./ability_icons/Storm_Surge_icon.png": 24528,
	"./ability_icons/Strafe_icon.png": 13771,
	"./ability_icons/Stroke_of_Fate_icon.png": 9548,
	"./ability_icons/Suicide_Squad,_Attack_icon.png": 50147,
	"./ability_icons/Summon_Familiars_icon.png": 99688,
	"./ability_icons/Summon_Spirit_Bear_icon.png": 76728,
	"./ability_icons/Summon_Wolves_icon.png": 34276,
	"./ability_icons/Sun_Ray_icon.png": 66551,
	"./ability_icons/Sun_Strike_icon.png": 75516,
	"./ability_icons/Sunder_icon.png": 41389,
	"./ability_icons/Supernova_icon.png": 77023,
	"./ability_icons/Surge_icon.png": 47033,
	"./ability_icons/Swashbuckle_icon.png": 97805,
	"./ability_icons/Swiftslash_icon.png": 26970,
	"./ability_icons/Tag_Team_icon.png": 66254,
	"./ability_icons/Take_Aim_icon.png": 93494,
	"./ability_icons/Telekinesis_Land_icon.png": 31883,
	"./ability_icons/Telekinesis_icon.png": 16228,
	"./ability_icons/Teleportation_icon.png": 39054,
	"./ability_icons/Tempest_Double_icon.png": 7313,
	"./ability_icons/Terror_Wave_icon.png": 34368,
	"./ability_icons/Terrorize_icon.png": 50426,
	"./ability_icons/Test_of_Faith_(Teleport)_icon.png": 91485,
	"./ability_icons/Test_of_Faith_icon.png": 84136,
	"./ability_icons/Tether_icon.png": 21114,
	"./ability_icons/The_Swarm_icon.png": 68866,
	"./ability_icons/Thirst_icon.png": 43967,
	"./ability_icons/Thunder_Clap_icon.png": 82743,
	"./ability_icons/Thunder_Strike_icon.png": 21045,
	"./ability_icons/Thundergod's_Wrath_icon.png": 59191,
	"./ability_icons/Tidal_Wave_icon.png": 55491,
	"./ability_icons/Tidebringer_icon.png": 97861,
	"./ability_icons/Timber_Chain_icon.png": 22679,
	"./ability_icons/Time_Dilation_icon.png": 23752,
	"./ability_icons/Time_Lapse_icon.png": 25542,
	"./ability_icons/Time_Lock_icon.png": 33655,
	"./ability_icons/Time_Walk_icon.png": 97788,
	"./ability_icons/Toggle_Movement_icon.png": 11839,
	"./ability_icons/Tombstone_icon.png": 15340,
	"./ability_icons/Tornado_icon.png": 69769,
	"./ability_icons/Torrent_Storm_icon.png": 76650,
	"./ability_icons/Torrent_icon.png": 44285,
	"./ability_icons/Toss_icon.png": 92799,
	"./ability_icons/Track_icon.png": 58664,
	"./ability_icons/Trample_icon.png": 28258,
	"./ability_icons/Trap_icon.png": 45720,
	"./ability_icons/Tree_Dance_icon.png": 23009,
	"./ability_icons/Tree_Grab_icon.png": 48417,
	"./ability_icons/Tree_Throw_icon.png": 95694,
	"./ability_icons/Tree_Volley_icon.png": 72930,
	"./ability_icons/Tricks_of_the_Trade_icon.png": 63245,
	"./ability_icons/True_Form_icon.png": 57966,
	"./ability_icons/Unburrow_icon.png": 32657,
	"./ability_icons/Unholy_Pact_icon.png": 30044,
	"./ability_icons/Unleash_icon.png": 63728,
	"./ability_icons/Unrefined_Fireblast_icon.png": 54071,
	"./ability_icons/Unstable_Concoction_Throw_icon.png": 23292,
	"./ability_icons/Unstable_Concoction_icon.png": 61658,
	"./ability_icons/Untouchable_icon.png": 52603,
	"./ability_icons/Upheaval_icon.png": 10401,
	"./ability_icons/Uproar_(max)_icon.png": 33249,
	"./ability_icons/Uproar_(none)_icon.png": 7584,
	"./ability_icons/Uproar_icon.png": 68610,
	"./ability_icons/Vacuum_icon.png": 69876,
	"./ability_icons/Vampiric_Aura_icon.png": 29944,
	"./ability_icons/Vendetta_icon.png": 76253,
	"./ability_icons/Vengeance_Aura_icon.png": 47280,
	"./ability_icons/Venomous_Gale_icon.png": 83890,
	"./ability_icons/Viper_Strike_icon.png": 79207,
	"./ability_icons/Viscous_Nasal_Goo_icon.png": 21744,
	"./ability_icons/Void_icon.png": 38586,
	"./ability_icons/Voodoo_Restoration_icon.png": 95567,
	"./ability_icons/Voodoo_Switcheroo_icon.png": 33186,
	"./ability_icons/Wall_of_Replica_icon.png": 51594,
	"./ability_icons/Walrus_Kick_icon.png": 84881,
	"./ability_icons/Walrus_Punch_icon.png": 26050,
	"./ability_icons/Waning_Rift_icon.png": 13890,
	"./ability_icons/Warcry_icon.png": 34763,
	"./ability_icons/Warpath_icon.png": 72730,
	"./ability_icons/Wave_of_Terror_icon.png": 31550,
	"./ability_icons/Waveform_icon.png": 18715,
	"./ability_icons/Wex_icon.png": 91981,
	"./ability_icons/Whirling_Axes_(Melee)_icon.png": 16443,
	"./ability_icons/Whirling_Axes_(Ranged)_icon.png": 29922,
	"./ability_icons/Whirling_Axes_icon.png": 85742,
	"./ability_icons/Whirling_Death_icon.png": 80411,
	"./ability_icons/Wild_Axes_icon.png": 77618,
	"./ability_icons/Will-O-Wisp_icon.png": 3244,
	"./ability_icons/Windrun_icon.png": 80241,
	"./ability_icons/Winter's_Curse_icon.png": 66753,
	"./ability_icons/Wolf_Bite_icon.png": 40033,
	"./ability_icons/Wraithfire_Blast_icon.png": 81282,
	"./ability_icons/Wrath_of_Nature_icon.png": 92240,
	"./ability_icons/Wukong's_Command_icon.png": 54745,
	"./ability_icons/X_Marks_the_Spot_icon.png": 99830,
	"./ability_icons/talent_tree.svg": 45533,
	"./buff_icons/abyssal_underlord_atrophy_aura.png": 94252,
	"./buff_icons/axe_culling_blade.png": 66215,
	"./buff_icons/bounty_hunter_jinada.png": 34389,
	"./buff_icons/legion_commander_duel.png": 76046,
	"./buff_icons/lion_finger_of_death.png": 22884,
	"./buff_icons/moon_shard.png": 76770,
	"./buff_icons/necrolyte_reapers_scythe.png": 30402,
	"./buff_icons/pudge_flesh_heap.png": 92311,
	"./buff_icons/silencer_glaives_of_wisdom.png": 26212,
	"./buff_icons/slark_essence_shift.png": 95947,
	"./buff_icons/tome_of_knowledge.png": 89851,
	"./hero_icons/Abaddon_icon.png": 30021,
	"./hero_icons/Alchemist_icon.png": 84099,
	"./hero_icons/Ancient_Apparition_icon.png": 82391,
	"./hero_icons/Anti-Mage_icon.png": 22091,
	"./hero_icons/Arc_Warden_icon.png": 50385,
	"./hero_icons/Axe_icon.png": 16321,
	"./hero_icons/Bane_icon.png": 55164,
	"./hero_icons/Batrider_icon.png": 20178,
	"./hero_icons/Beastmaster_icon.png": 2592,
	"./hero_icons/Bloodseeker_icon.png": 75594,
	"./hero_icons/Bounty_Hunter_icon.png": 12567,
	"./hero_icons/Brewmaster_icon.png": 27043,
	"./hero_icons/Bristleback_icon.png": 49275,
	"./hero_icons/Broodmother_icon.png": 8434,
	"./hero_icons/Centaur_Warrunner_icon.png": 65620,
	"./hero_icons/Chaos_Knight_icon.png": 93867,
	"./hero_icons/Chen_icon.png": 17075,
	"./hero_icons/Clinkz_icon.png": 68899,
	"./hero_icons/Clockwerk_icon.png": 11717,
	"./hero_icons/Crystal_Maiden_icon.png": 33652,
	"./hero_icons/Dark_Seer_icon.png": 12013,
	"./hero_icons/Dark_Willow_icon.png": 760,
	"./hero_icons/Dawnbreaker_icon.png": 82934,
	"./hero_icons/Dazzle_icon.png": 79062,
	"./hero_icons/Death_Prophet_icon.png": 13577,
	"./hero_icons/Disruptor_icon.png": 23710,
	"./hero_icons/Doom_icon.png": 94534,
	"./hero_icons/Dragon_Knight_icon.png": 93313,
	"./hero_icons/Drow_Ranger_icon.png": 17227,
	"./hero_icons/Earth_Spirit_icon.png": 61950,
	"./hero_icons/Earthshaker_icon.png": 20828,
	"./hero_icons/Elder_Titan_icon.png": 15143,
	"./hero_icons/Ember_Spirit_icon.png": 90027,
	"./hero_icons/Enchantress_icon.png": 41804,
	"./hero_icons/Enigma_icon.png": 13376,
	"./hero_icons/Faceless_Void_icon.png": 80250,
	"./hero_icons/Grimstroke_icon.png": 78265,
	"./hero_icons/Gyrocopter_icon.png": 34860,
	"./hero_icons/Hoodwink_icon.png": 70458,
	"./hero_icons/Huskar_icon.png": 57898,
	"./hero_icons/Invoker_icon.png": 11821,
	"./hero_icons/Io_icon.png": 6280,
	"./hero_icons/Jakiro_icon.png": 70058,
	"./hero_icons/Juggernaut_icon.png": 75390,
	"./hero_icons/Keeper_of_the_Light_icon.png": 54411,
	"./hero_icons/Kunkka_icon.png": 88907,
	"./hero_icons/Legion_Commander_icon.png": 24874,
	"./hero_icons/Leshrac_icon.png": 39367,
	"./hero_icons/Lich_icon.png": 48998,
	"./hero_icons/Lifestealer_icon.png": 37255,
	"./hero_icons/Lina_icon.png": 83437,
	"./hero_icons/Lion_icon.png": 36116,
	"./hero_icons/Lone_Druid_icon.png": 41159,
	"./hero_icons/Luna_icon.png": 9185,
	"./hero_icons/Lycan_icon.png": 30857,
	"./hero_icons/Magnus_icon.png": 25550,
	"./hero_icons/Marci_icon.png": 40412,
	"./hero_icons/Mars_icon.png": 48256,
	"./hero_icons/Medusa_icon.png": 68216,
	"./hero_icons/Meepo_icon.png": 76913,
	"./hero_icons/Mirana_icon.png": 53447,
	"./hero_icons/Monkey_King_icon.png": 36640,
	"./hero_icons/Morphling_icon.png": 90391,
	"./hero_icons/Naga_Siren_icon.png": 99436,
	"./hero_icons/Nature's_Prophet_icon.png": 46919,
	"./hero_icons/Necrophos_icon.png": 89188,
	"./hero_icons/Night_Stalker_icon.png": 51199,
	"./hero_icons/Nyx_Assassin_icon.png": 71322,
	"./hero_icons/Ogre_Magi_icon.png": 3122,
	"./hero_icons/Omniknight_icon.png": 94214,
	"./hero_icons/Oracle_icon.png": 70054,
	"./hero_icons/Outworld_Destroyer_icon.png": 70103,
	"./hero_icons/Pangolier_icon.png": 1727,
	"./hero_icons/Phantom_Assassin_icon.png": 20490,
	"./hero_icons/Phantom_Lancer_icon.png": 84369,
	"./hero_icons/Phoenix_icon.png": 41444,
	"./hero_icons/Primal_Beast_icon.png": 89976,
	"./hero_icons/Puck_icon.png": 57953,
	"./hero_icons/Pudge_icon.png": 98426,
	"./hero_icons/Pugna_icon.png": 82067,
	"./hero_icons/Queen_of_Pain_icon.png": 77529,
	"./hero_icons/Razor_icon.png": 85386,
	"./hero_icons/Riki_icon.png": 49752,
	"./hero_icons/Rubick_icon.png": 63261,
	"./hero_icons/Sand_King_icon.png": 42960,
	"./hero_icons/Shadow_Demon_icon.png": 73375,
	"./hero_icons/Shadow_Fiend_icon.png": 55507,
	"./hero_icons/Shadow_Shaman_icon.png": 28987,
	"./hero_icons/Silencer_icon.png": 62055,
	"./hero_icons/Skeleton_King_icon.png": 43860,
	"./hero_icons/Skywrath_Mage_icon.png": 35472,
	"./hero_icons/Slardar_icon.png": 43916,
	"./hero_icons/Slark_icon.png": 91682,
	"./hero_icons/Snapfire_icon.png": 58078,
	"./hero_icons/Sniper_icon.png": 66034,
	"./hero_icons/Spectre_icon.png": 36281,
	"./hero_icons/Spirit_Breaker_icon.png": 18941,
	"./hero_icons/Storm_Spirit_icon.png": 29222,
	"./hero_icons/Sven_icon.png": 74948,
	"./hero_icons/Techies_icon.png": 37229,
	"./hero_icons/Templar_Assassin_icon.png": 72914,
	"./hero_icons/Terrorblade_icon.png": 32609,
	"./hero_icons/Tidehunter_icon.png": 60102,
	"./hero_icons/Timbersaw_icon.png": 45654,
	"./hero_icons/Tinker_icon.png": 97663,
	"./hero_icons/Tiny_icon.png": 63658,
	"./hero_icons/Treant_Protector_icon.png": 69688,
	"./hero_icons/Troll_Warlord_icon.png": 47919,
	"./hero_icons/Tusk_icon.png": 26763,
	"./hero_icons/Underlord_icon.png": 57994,
	"./hero_icons/Undying_icon.png": 47525,
	"./hero_icons/Ursa_icon.png": 34349,
	"./hero_icons/Vengeful_Spirit_icon.png": 48300,
	"./hero_icons/Venomancer_icon.png": 66120,
	"./hero_icons/Viper_icon.png": 71266,
	"./hero_icons/Visage_icon.png": 9038,
	"./hero_icons/Void_Spirit_icon.png": 63042,
	"./hero_icons/Warlock_icon.png": 47085,
	"./hero_icons/Weaver_icon.png": 10501,
	"./hero_icons/Windranger_icon.png": 19989,
	"./hero_icons/Winter_Wyvern_icon.png": 42368,
	"./hero_icons/Witch_Doctor_icon.png": 52921,
	"./hero_icons/Wraith_King_icon.png": 58706,
	"./hero_icons/Zeus_icon.png": 83270,
	"./item_icons/Abyssal_Blade_icon.png": 23991,
	"./item_icons/Abyssal_Blade_recipe_icon.png": 85708,
	"./item_icons/Aegis_of_the_Immortal_(Valentine's_Day)_icon.png": 19142,
	"./item_icons/Aegis_of_the_Immortal_icon.png": 82621,
	"./item_icons/Aeon_Disk_icon.png": 98250,
	"./item_icons/Aeon_Disk_recipe_icon.png": 63244,
	"./item_icons/Aether_Lens_icon.png": 85995,
	"./item_icons/Aether_Lens_recipe_icon.png": 42202,
	"./item_icons/Aghanim's_Blessing_-_Roshan_icon.png": 41456,
	"./item_icons/Aghanim's_Blessing_icon.png": 99245,
	"./item_icons/Aghanim's_Blessing_recipe_icon.png": 47659,
	"./item_icons/Aghanim's_Scepter_(2020_Summer_Event)_1_icon.png": 64932,
	"./item_icons/Aghanim's_Scepter_(2020_Summer_Event)_2_icon.png": 43063,
	"./item_icons/Aghanim's_Scepter_icon.png": 92131,
	"./item_icons/Aghanim's_Shard_-_Roshan_icon.png": 41919,
	"./item_icons/Aghanim's_Shard_icon.png": 62915,
	"./item_icons/Animal_Courier_(Dire)_icon.png": 14573,
	"./item_icons/Animal_Courier_(Radiant)_icon.png": 41588,
	"./item_icons/Apex_icon.png": 84771,
	"./item_icons/Arcane_Blink_icon.png": 27235,
	"./item_icons/Arcane_Blink_recipe_icon.png": 13701,
	"./item_icons/Arcane_Boots_icon.png": 53707,
	"./item_icons/Arcane_Ring_icon.png": 85956,
	"./item_icons/Arcanist's_Armor_icon.png": 31173,
	"./item_icons/Armlet_of_Mordiggian_(Active)_icon.png": 86968,
	"./item_icons/Armlet_of_Mordiggian_(Inactive)_icon.png": 39970,
	"./item_icons/Armlet_of_Mordiggian_icon.png": 49386,
	"./item_icons/Armlet_of_Mordiggian_recipe_icon.png": 61275,
	"./item_icons/Ascetic's_Cap_icon.png": 46324,
	"./item_icons/Assault_Cuirass_icon.png": 55643,
	"./item_icons/Assault_Cuirass_recipe_icon.png": 87105,
	"./item_icons/Ballista_icon.png": 8141,
	"./item_icons/Banana_icon.png": 59664,
	"./item_icons/Band_of_Elvenskin_icon.png": 30671,
	"./item_icons/Battle_Fury_icon.png": 59115,
	"./item_icons/Battle_Fury_recipe_icon.png": 36700,
	"./item_icons/Belt_of_Strength_icon.png": 59646,
	"./item_icons/Black_King_Bar_icon.png": 18782,
	"./item_icons/Black_King_Bar_recipe_icon.png": 97295,
	"./item_icons/Blade_Mail_icon.png": 60541,
	"./item_icons/Blade_Mail_recipe_icon.png": 48357,
	"./item_icons/Blade_of_Alacrity_icon.png": 91298,
	"./item_icons/Blades_of_Attack_icon.png": 4536,
	"./item_icons/Blast_Rig_icon.png": 92161,
	"./item_icons/Blight_Stone_icon.png": 15719,
	"./item_icons/Blink_Dagger_icon.png": 56657,
	"./item_icons/Blitz_Knuckles_icon.png": 7426,
	"./item_icons/Bloodstone_icon.png": 74547,
	"./item_icons/Bloodstone_recipe_icon.png": 98593,
	"./item_icons/Bloodthorn_icon.png": 1010,
	"./item_icons/Bloodthorn_recipe_icon.png": 89393,
	"./item_icons/Book_of_Shadows_icon.png": 41379,
	"./item_icons/Book_of_the_Dead_icon.png": 24657,
	"./item_icons/Boots_of_Bearing_icon.png": 17635,
	"./item_icons/Boots_of_Bearing_recipe_icon.png": 28038,
	"./item_icons/Boots_of_Speed_icon.png": 21877,
	"./item_icons/Boots_of_Travel_1_icon.png": 62770,
	"./item_icons/Boots_of_Travel_2_icon.png": 26820,
	"./item_icons/Boots_of_Travel_icon.png": 48322,
	"./item_icons/Boots_of_Travel_recipe_icon.png": 20521,
	"./item_icons/Bottle_(Arcane)_icon.png": 76106,
	"./item_icons/Bottle_(Bounty)_icon.png": 83381,
	"./item_icons/Bottle_(Double_Damage)_icon.png": 28905,
	"./item_icons/Bottle_(Empty)_icon.png": 63176,
	"./item_icons/Bottle_(Full)_icon.png": 588,
	"./item_icons/Bottle_(Haste)_icon.png": 74225,
	"./item_icons/Bottle_(Illusion)_icon.png": 92307,
	"./item_icons/Bottle_(Invisibility)_icon.png": 16463,
	"./item_icons/Bottle_(Medium)_icon.png": 31074,
	"./item_icons/Bottle_(Regeneration)_icon.png": 80770,
	"./item_icons/Bottle_(Small)_icon.png": 4945,
	"./item_icons/Bottle_(Water)_icon.png": 53670,
	"./item_icons/Bottle_icon.png": 42354,
	"./item_icons/Bracer_icon.png": 72830,
	"./item_icons/Bracer_recipe_icon.png": 22317,
	"./item_icons/Brigand's_Blade_icon.png": 73716,
	"./item_icons/Broadsword_icon.png": 80150,
	"./item_icons/Broom_Handle_icon.png": 12222,
	"./item_icons/Buckler_(Active)_icon.png": 50117,
	"./item_icons/Buckler_(Inactive)_icon.png": 63613,
	"./item_icons/Buckler_icon.png": 10769,
	"./item_icons/Buckler_recipe_icon.png": 24994,
	"./item_icons/Bullwhip_icon.png": 4166,
	"./item_icons/Butterfly_icon.png": 64244,
	"./item_icons/Ceremonial_Robe_icon.png": 38115,
	"./item_icons/Chainmail_icon.png": 36074,
	"./item_icons/Cheese_icon.png": 73652,
	"./item_icons/Chipped_Vest_icon.png": 28122,
	"./item_icons/Circlet_icon.png": 42454,
	"./item_icons/Clarity_icon.png": 96479,
	"./item_icons/Claymore_icon.png": 37987,
	"./item_icons/Cloak_icon.png": 92197,
	"./item_icons/Cloak_of_Flames_icon.png": 16406,
	"./item_icons/Clumsy_Net_icon.png": 65038,
	"./item_icons/Craggy_Coat_icon.png": 37847,
	"./item_icons/Crimson_Guard_icon.png": 77427,
	"./item_icons/Crimson_Guard_recipe_icon.png": 37375,
	"./item_icons/Crown_icon.png": 21850,
	"./item_icons/Crystalys_icon.png": 12401,
	"./item_icons/Crystalys_recipe_icon.png": 87812,
	"./item_icons/Daedalus_icon.png": 52742,
	"./item_icons/Daedalus_recipe_icon.png": 68549,
	"./item_icons/Dagon_1_icon.png": 10965,
	"./item_icons/Dagon_2_icon.png": 98867,
	"./item_icons/Dagon_3_icon.png": 42344,
	"./item_icons/Dagon_4_icon.png": 6790,
	"./item_icons/Dagon_5_icon.png": 44813,
	"./item_icons/Dagon_recipe_icon.png": 18281,
	"./item_icons/Default_recipe_icon.png": 24309,
	"./item_icons/Demon_Edge_icon.png": 51711,
	"./item_icons/Desolator_icon.png": 29451,
	"./item_icons/Diffusal_Blade_1_icon.png": 71902,
	"./item_icons/Diffusal_Blade_2_icon.png": 77555,
	"./item_icons/Diffusal_Blade_icon.png": 44139,
	"./item_icons/Diffusal_Blade_recipe_icon.png": 53249,
	"./item_icons/Dimensional_Doorway_icon.png": 77572,
	"./item_icons/Divine_Rapier_icon.png": 45020,
	"./item_icons/Dragon_Lance_icon.png": 96169,
	"./item_icons/Dragon_Scale_icon.png": 96798,
	"./item_icons/Drum_of_Endurance_icon.png": 17754,
	"./item_icons/Drum_of_Endurance_recipe_icon.png": 44203,
	"./item_icons/Dust_of_Appearance_icon.png": 22220,
	"./item_icons/Eaglesong_icon.png": 89708,
	"./item_icons/Echo_Sabre_icon.png": 78289,
	"./item_icons/Elixir_1_icon.png": 21157,
	"./item_icons/Elixir_2_icon.png": 59400,
	"./item_icons/Elixir_3_icon.png": 63183,
	"./item_icons/Elixir_4_icon.png": 44478,
	"./item_icons/Elven_Tunic_icon.png": 64826,
	"./item_icons/Enchanted_Mango_icon.png": 94050,
	"./item_icons/Enchanted_Quiver_icon.png": 5702,
	"./item_icons/Energy_Booster_icon.png": 85570,
	"./item_icons/Essence_Ring_icon.png": 27187,
	"./item_icons/Eternal_Shroud_icon.png": 1486,
	"./item_icons/Eternal_Shroud_recipe_icon.png": 7314,
	"./item_icons/Ethereal_Blade_icon.png": 50977,
	"./item_icons/Ethereal_Blade_recipe_icon.png": 30662,
	"./item_icons/Eul's_Scepter_of_Divinity_icon.png": 66514,
	"./item_icons/Eul's_Scepter_of_Divinity_recipe_icon.png": 72364,
	"./item_icons/Ex_Machina_icon.png": 72134,
	"./item_icons/Eye_of_Skadi_icon.png": 19073,
	"./item_icons/Faded_Broach_icon.png": 31896,
	"./item_icons/Fae_Grenade_icon.png": 24989,
	"./item_icons/Faerie_Fire_icon.png": 79765,
	"./item_icons/Fairy's_Trinket_icon.png": 15690,
	"./item_icons/Falcon_Blade_icon.png": 2689,
	"./item_icons/Falcon_Blade_recipe_icon.png": 42190,
	"./item_icons/Fallen_Sky_icon.png": 55216,
	"./item_icons/Fallen_Sky_recipe_icon.png": 86299,
	"./item_icons/Flicker_icon.png": 39535,
	"./item_icons/Fluffy_Hat_icon.png": 12650,
	"./item_icons/Flying_Courier_(Dire)_icon.png": 88018,
	"./item_icons/Flying_Courier_(Radiant)_icon.png": 54760,
	"./item_icons/Force_Boots_icon.png": 48388,
	"./item_icons/Force_Staff_icon.png": 36771,
	"./item_icons/Force_Staff_recipe_icon.png": 43922,
	"./item_icons/Fusion_Rune_icon.png": 55559,
	"./item_icons/Gauntlets_of_Strength_icon.png": 34958,
	"./item_icons/Gem_of_True_Sight_icon.png": 13076,
	"./item_icons/Ghost_Scepter_icon.png": 48944,
	"./item_icons/Giant's_Ring_icon.png": 51814,
	"./item_icons/Gleipnir_icon.png": 21156,
	"./item_icons/Gleipnir_recipe_icon.png": 57361,
	"./item_icons/Glimmer_Cape_icon.png": 83159,
	"./item_icons/Glimmer_Cape_recipe_icon.png": 52347,
	"./item_icons/Gloves_of_Haste_icon.png": 96751,
	"./item_icons/Greater_Faerie_Fire_icon.png": 72167,
	"./item_icons/Greater_Mango_icon.png": 70461,
	"./item_icons/Grove_Bow_icon.png": 79336,
	"./item_icons/Guardian_Greaves_icon.png": 25106,
	"./item_icons/Guardian_Greaves_recipe_icon.png": 25235,
	"./item_icons/Hand_of_Midas_icon.png": 6009,
	"./item_icons/Hand_of_Midas_recipe_icon.png": 40781,
	"./item_icons/Havoc_Hammer_icon.png": 14957,
	"./item_icons/Headdress_icon.png": 26691,
	"./item_icons/Headdress_recipe_icon.png": 95502,
	"./item_icons/Healing_Salve_icon.png": 85974,
	"./item_icons/Heart_of_Tarrasque_icon.png": 82935,
	"./item_icons/Heart_of_Tarrasque_recipe_icon.png": 31007,
	"./item_icons/Heaven's_Halberd_icon.png": 67269,
	"./item_icons/Heaven's_Halberd_recipe_icon.png": 7272,
	"./item_icons/Helm_of_Iron_Will_icon.png": 37809,
	"./item_icons/Helm_of_the_Dominator_2_recipe_icon.png": 75221,
	"./item_icons/Helm_of_the_Dominator_icon.png": 10627,
	"./item_icons/Helm_of_the_Dominator_recipe_icon.png": 7985,
	"./item_icons/Helm_of_the_Overlord_icon.png": 25839,
	"./item_icons/Helm_of_the_Undying_icon.png": 87280,
	"./item_icons/Holy_Locket_icon.png": 6459,
	"./item_icons/Holy_Locket_recipe_icon.png": 2667,
	"./item_icons/Hood_of_Defiance_icon.png": 44338,
	"./item_icons/Horizon_icon.png": 35015,
	"./item_icons/Hurricane_Pike_icon.png": 79560,
	"./item_icons/Hurricane_Pike_recipe_icon.png": 11130,
	"./item_icons/Hyperstone_icon.png": 76543,
	"./item_icons/Illusionist's_Cape_icon.png": 49703,
	"./item_icons/Imp_Claw_icon.png": 42907,
	"./item_icons/Infused_Raindrops_icon.png": 26941,
	"./item_icons/Iron_Branch_icon.png": 39989,
	"./item_icons/Iron_Talon_icon.png": 63373,
	"./item_icons/Iron_Talon_recipe_icon.png": 35188,
	"./item_icons/Ironwood_Tree_icon.png": 95107,
	"./item_icons/Ironwood_Tree_recipe_icon.png": 11643,
	"./item_icons/Javelin_icon.png": 47930,
	"./item_icons/Kaya_and_Sange_icon.png": 60757,
	"./item_icons/Kaya_icon.png": 33618,
	"./item_icons/Kaya_recipe_icon.png": 74673,
	"./item_icons/Keen_Optic_icon.png": 18951,
	"./item_icons/Linken's_Sphere_icon.png": 2521,
	"./item_icons/Linken's_Sphere_recipe_icon.png": 61515,
	"./item_icons/Lotus_Orb_icon.png": 91726,
	"./item_icons/Maelstrom_icon.png": 21213,
	"./item_icons/Maelstrom_recipe_icon.png": 87275,
	"./item_icons/Mage_Slayer_icon.png": 52954,
	"./item_icons/Mage_Slayer_recipe_icon.png": 83502,
	"./item_icons/Magic_Lamp_icon.png": 63691,
	"./item_icons/Magic_Stick_icon.png": 16397,
	"./item_icons/Magic_Wand_icon.png": 8572,
	"./item_icons/Magic_Wand_recipe_icon.png": 56361,
	"./item_icons/Mango_Tree_icon.png": 40642,
	"./item_icons/Manta_Style_icon.png": 13008,
	"./item_icons/Manta_Style_recipe_icon.png": 56528,
	"./item_icons/Mantle_of_Intelligence_icon.png": 47215,
	"./item_icons/Mask_of_Madness_icon.png": 28872,
	"./item_icons/Medallion_of_Courage_icon.png": 8152,
	"./item_icons/Mekansm_icon.png": 92196,
	"./item_icons/Mekansm_recipe_icon.png": 37915,
	"./item_icons/Meteor_Hammer_icon.png": 26409,
	"./item_icons/Meteor_Hammer_recipe_icon.png": 58455,
	"./item_icons/Mind_Breaker_icon.png": 41481,
	"./item_icons/Minotaur_Horn_icon.png": 98863,
	"./item_icons/Mirror_Shield_icon.png": 82378,
	"./item_icons/Mithril_Hammer_icon.png": 56095,
	"./item_icons/Mjollnir_icon.png": 83603,
	"./item_icons/Mjollnir_recipe_icon.png": 94063,
	"./item_icons/Monkey_King_Bar_icon.png": 90936,
	"./item_icons/Monkey_King_Bar_recipe_icon.png": 37435,
	"./item_icons/Moon_Shard_icon.png": 76407,
	"./item_icons/Morbid_Mask_icon.png": 6817,
	"./item_icons/Mystic_Staff_icon.png": 6846,
	"./item_icons/Necronomicon_1_icon.png": 69471,
	"./item_icons/Necronomicon_2_icon.png": 41608,
	"./item_icons/Necronomicon_3_icon.png": 34593,
	"./item_icons/Necronomicon_recipe_icon.png": 71195,
	"./item_icons/Nether_Shawl_icon.png": 19438,
	"./item_icons/Ninja_Gear_icon.png": 58382,
	"./item_icons/Null_Talisman_icon.png": 31556,
	"./item_icons/Null_Talisman_recipe_icon.png": 33572,
	"./item_icons/Nullifier_icon.png": 26556,
	"./item_icons/Oblivion_Staff_icon.png": 32631,
	"./item_icons/Observer_Ward_icon.png": 15587,
	"./item_icons/Observer_and_Sentry_Wards_1_icon.png": 68543,
	"./item_icons/Observer_and_Sentry_Wards_2_icon.png": 32201,
	"./item_icons/Observer_and_Sentry_Wards_icon.png": 86505,
	"./item_icons/Ocean_Heart_icon.png": 9952,
	"./item_icons/Octarine_Core_icon.png": 39194,
	"./item_icons/Octarine_Core_recipe_icon.png": 98505,
	"./item_icons/Ogre_Axe_icon.png": 28794,
	"./item_icons/Orb_of_Corrosion_icon.png": 30655,
	"./item_icons/Orb_of_Corrosion_recipe_icon.png": 25581,
	"./item_icons/Orb_of_Destruction_icon.png": 40428,
	"./item_icons/Orb_of_Venom_icon.png": 59042,
	"./item_icons/Orchid_Malevolence_icon.png": 51097,
	"./item_icons/Orchid_Malevolence_recipe_icon.png": 57609,
	"./item_icons/Overwhelming_Blink_icon.png": 90063,
	"./item_icons/Overwhelming_Blink_recipe_icon.png": 9378,
	"./item_icons/Paladin_Sword_icon.png": 58215,
	"./item_icons/Penta-Edged_Sword_icon.png": 2393,
	"./item_icons/Perseverance_icon.png": 24546,
	"./item_icons/Phase_Boots_icon.png": 34710,
	"./item_icons/Philosopher's_Stone_icon.png": 72592,
	"./item_icons/Phoenix_Ash_icon.png": 21403,
	"./item_icons/Pig_Pole_icon.png": 3667,
	"./item_icons/Pipe_of_Insight_icon.png": 47108,
	"./item_icons/Pipe_of_Insight_recipe_icon.png": 5390,
	"./item_icons/Pirate_Hat_icon.png": 62271,
	"./item_icons/Platemail_icon.png": 94922,
	"./item_icons/Point_Booster_icon.png": 41403,
	"./item_icons/Poor_Man's_Shield_icon.png": 64917,
	"./item_icons/Possessed_Mask_icon.png": 51646,
	"./item_icons/Power_Treads_(Agility)_icon.png": 95774,
	"./item_icons/Power_Treads_(Agility_Colorblind)_icon.png": 30335,
	"./item_icons/Power_Treads_(Intelligence)_icon.png": 74074,
	"./item_icons/Power_Treads_(Strength)_icon.png": 25187,
	"./item_icons/Power_Treads_icon.png": 29254,
	"./item_icons/Prince's_Knife_icon.png": 86486,
	"./item_icons/Psychic_Headband_icon.png": 34641,
	"./item_icons/Pupil's_Gift_icon.png": 97232,
	"./item_icons/Quarterstaff_icon.png": 26599,
	"./item_icons/Quelling_Blade_icon.png": 12982,
	"./item_icons/Quickening_Charm_icon.png": 90551,
	"./item_icons/Quicksilver_Amulet_icon.png": 20486,
	"./item_icons/Radiance_(Active)_icon.png": 41493,
	"./item_icons/Radiance_(Inactive)_icon.png": 2094,
	"./item_icons/Radiance_icon.png": 49166,
	"./item_icons/Radiance_recipe_icon.png": 13571,
	"./item_icons/Reaver_icon.png": 65330,
	"./item_icons/Refresher_Orb_icon.png": 42164,
	"./item_icons/Refresher_Orb_recipe_icon.png": 33312,
	"./item_icons/Repair_Kit_icon.png": 35555,
	"./item_icons/Revenant's_Brooch_icon.png": 15165,
	"./item_icons/Revenant's_Brooch_recipe_icon.png": 9315,
	"./item_icons/Ring_of_Aquila_(Active)_icon.png": 78221,
	"./item_icons/Ring_of_Aquila_(Inactive)_icon.png": 9692,
	"./item_icons/Ring_of_Aquila_icon.png": 40601,
	"./item_icons/Ring_of_Basilius_(Active)_icon.png": 89597,
	"./item_icons/Ring_of_Basilius_(Inactive)_icon.png": 74779,
	"./item_icons/Ring_of_Basilius_icon.png": 34798,
	"./item_icons/Ring_of_Basilius_recipe_icon.png": 28135,
	"./item_icons/Ring_of_Health_icon.png": 76474,
	"./item_icons/Ring_of_Protection_icon.png": 44562,
	"./item_icons/Ring_of_Regen_icon.png": 47547,
	"./item_icons/Ring_of_Tarrasque_icon.png": 90383,
	"./item_icons/Robe_of_the_Magi_icon.png": 18442,
	"./item_icons/Rod_of_Atos_icon.png": 75823,
	"./item_icons/Rod_of_Atos_recipe_icon.png": 46000,
	"./item_icons/Royal_Jelly_1_icon.png": 10114,
	"./item_icons/Royal_Jelly_2_icon.png": 91942,
	"./item_icons/Sacred_Relic_icon.png": 2772,
	"./item_icons/Sage's_Mask_icon.png": 22330,
	"./item_icons/Sange_and_Yasha_icon.png": 36244,
	"./item_icons/Sange_icon.png": 57881,
	"./item_icons/Sange_recipe_icon.png": 99173,
	"./item_icons/Satanic_icon.png": 14339,
	"./item_icons/Satanic_recipe_icon.png": 9228,
	"./item_icons/Scythe_of_Vyse_icon.png": 40090,
	"./item_icons/Seer_Stone_icon.png": 58806,
	"./item_icons/Sentry_Ward_icon.png": 37979,
	"./item_icons/Shadow_Amulet_icon.png": 22127,
	"./item_icons/Shadow_Blade_icon.png": 61574,
	"./item_icons/Shiva's_Guard_icon.png": 75256,
	"./item_icons/Shiva's_Guard_recipe_icon.png": 96884,
	"./item_icons/Silver_Edge_icon.png": 76499,
	"./item_icons/Silver_Edge_recipe_icon.png": 24088,
	"./item_icons/Skull_Basher_icon.png": 48171,
	"./item_icons/Skull_Basher_recipe_icon.png": 93346,
	"./item_icons/Slippers_of_Agility_icon.png": 15912,
	"./item_icons/Smoke_of_Deceit_icon.png": 74241,
	"./item_icons/Solar_Crest_icon.png": 59050,
	"./item_icons/Solar_Crest_recipe_icon.png": 95793,
	"./item_icons/Soul_Booster_icon.png": 79138,
	"./item_icons/Soul_Ring_icon.png": 2472,
	"./item_icons/Soul_Ring_recipe_icon.png": 4056,
	"./item_icons/Spell_Prism_icon.png": 26842,
	"./item_icons/Spider_Legs_icon.png": 42978,
	"./item_icons/Spirit_Vessel_icon.png": 1846,
	"./item_icons/Spirit_Vessel_recipe_icon.png": 74070,
	"./item_icons/Staff_of_Wizardry_icon.png": 12619,
	"./item_icons/Stormcrafter_icon.png": 57899,
	"./item_icons/Stout_Shield_icon.png": 12607,
	"./item_icons/Stygian_Desolator_icon.png": 83280,
	"./item_icons/Swift_Blink_icon.png": 50070,
	"./item_icons/Swift_Blink_recipe_icon.png": 16100,
	"./item_icons/Talisman_of_Evasion_icon.png": 78762,
	"./item_icons/Tango_(Shared)_icon.png": 21619,
	"./item_icons/Tango_icon.png": 81888,
	"./item_icons/Telescope_icon.png": 87370,
	"./item_icons/The_Leveller_icon.png": 84174,
	"./item_icons/Third_Eye_icon.png": 48026,
	"./item_icons/Timeless_Relic_icon.png": 45918,
	"./item_icons/Titan_Sliver_icon.png": 65672,
	"./item_icons/Tome_of_Aghanim_icon.png": 59864,
	"./item_icons/Tome_of_Knowledge_icon.png": 90234,
	"./item_icons/Town_Portal_Scroll_icon.png": 17146,
	"./item_icons/Tranquil_Boots_(Active)_icon.png": 11618,
	"./item_icons/Tranquil_Boots_(Inactive)_icon.png": 72225,
	"./item_icons/Tranquil_Boots_icon.png": 6753,
	"./item_icons/Trickster_Cloak_icon.png": 46490,
	"./item_icons/Trident_icon.png": 69425,
	"./item_icons/Trident_recipe_icon.png": 48058,
	"./item_icons/Trusty_Shovel_icon.png": 82273,
	"./item_icons/Tumbler's_Toy_icon.png": 47159,
	"./item_icons/Ultimate_Orb_icon.png": 9659,
	"./item_icons/Urn_of_Shadows_icon.png": 58752,
	"./item_icons/Urn_of_Shadows_recipe_icon.png": 10295,
	"./item_icons/Vambrace_(Agility)_icon.png": 83386,
	"./item_icons/Vambrace_(Intelligence)_icon.png": 61833,
	"./item_icons/Vambrace_(Strength)_icon.png": 48392,
	"./item_icons/Vampire_Fangs_icon.png": 37612,
	"./item_icons/Vanguard_icon.png": 30094,
	"./item_icons/Veil_of_Discord_icon.png": 61237,
	"./item_icons/Veil_of_Discord_recipe_icon.png": 49100,
	"./item_icons/Vitality_Booster_icon.png": 7088,
	"./item_icons/Vladmir's_Offering_icon.png": 93795,
	"./item_icons/Vladmir's_Offering_recipe_icon.png": 76571,
	"./item_icons/Void_Stone_icon.png": 75648,
	"./item_icons/Voodoo_Mask_icon.png": 54315,
	"./item_icons/Wind_Lace_icon.png": 4645,
	"./item_icons/Wind_Waker_icon.png": 96820,
	"./item_icons/Wind_Waker_recipe_icon.png": 55962,
	"./item_icons/Witch_Blade_icon.png": 70063,
	"./item_icons/Witch_Blade_recipe_icon.png": 85638,
	"./item_icons/Witchbane_icon.png": 69730,
	"./item_icons/Witless_Shako_icon.png": 71932,
	"./item_icons/Woodland_Striders_icon.png": 51284,
	"./item_icons/Wraith_Band_icon.png": 34320,
	"./item_icons/Wraith_Band_recipe_icon.png": 26,
	"./item_icons/Wraith_Pact_icon.png": 10578,
	"./item_icons/Wraith_Pact_recipe_icon.png": 56415,
	"./item_icons/Yasha_and_Kaya_icon.png": 86517,
	"./item_icons/Yasha_icon.png": 69757,
	"./item_icons/Yasha_recipe_icon.png": 64625,
	"./item_icons/aghanims_shard.png": 71504,
	"./item_icons/aghanims_shard_active.png": 10741,
	"./item_icons/ultimate_scepter.png": 93621,
	"./item_icons/ultimate_scepter_activated.png": 81294,
	"./map_icons/badguys_fort.png": 98144,
	"./map_icons/badguys_rax.png": 32676,
	"./map_icons/badguys_rax_angle.png": 77890,
	"./map_icons/badguys_tower.png": 82171,
	"./map_icons/badguys_tower_angle.png": 24914,
	"./map_icons/goodguys_fort.png": 22183,
	"./map_icons/goodguys_rax.png": 51477,
	"./map_icons/goodguys_rax_angle.png": 2993,
	"./map_icons/goodguys_tower.png": 70698,
	"./map_icons/goodguys_tower_angle.png": 58125,
	"./map_icons/heroes/Abaddon_minimap_icon.png": 41878,
	"./map_icons/heroes/Alchemist_minimap_icon.png": 43685,
	"./map_icons/heroes/Ancient_Apparition_minimap_icon.png": 19283,
	"./map_icons/heroes/Anti-Mage_minimap_icon.png": 88892,
	"./map_icons/heroes/Arc_Warden_minimap_icon.png": 10785,
	"./map_icons/heroes/Axe_minimap_icon.png": 84231,
	"./map_icons/heroes/Bane_minimap_icon.png": 96666,
	"./map_icons/heroes/Batrider_minimap_icon.png": 5007,
	"./map_icons/heroes/Beastmaster_minimap_icon.png": 59123,
	"./map_icons/heroes/Bloodseeker_minimap_icon.png": 36731,
	"./map_icons/heroes/Bounty_Hunter_minimap_icon.png": 58111,
	"./map_icons/heroes/Brewmaster_minimap_icon.png": 75404,
	"./map_icons/heroes/Bristleback_minimap_icon.png": 56210,
	"./map_icons/heroes/Broodmother_minimap_icon.png": 88678,
	"./map_icons/heroes/Centaur_Warrunner_minimap_icon.png": 68877,
	"./map_icons/heroes/Chaos_Knight_minimap_icon.png": 61430,
	"./map_icons/heroes/Chen_minimap_icon.png": 74092,
	"./map_icons/heroes/Clinkz_minimap_icon.png": 11330,
	"./map_icons/heroes/Clockwerk_minimap_icon.png": 43295,
	"./map_icons/heroes/Crystal_Maiden_minimap_icon.png": 14670,
	"./map_icons/heroes/Dark_Seer_minimap_icon.png": 5676,
	"./map_icons/heroes/Dark_Willow_minimap_icon.png": 30239,
	"./map_icons/heroes/Dawnbreaker_minimap_icon.png": 78982,
	"./map_icons/heroes/Dazzle_minimap_icon.png": 55594,
	"./map_icons/heroes/Death_Prophet_minimap_icon.png": 3692,
	"./map_icons/heroes/Disruptor_minimap_icon.png": 6011,
	"./map_icons/heroes/Doom_minimap_icon.png": 6552,
	"./map_icons/heroes/Dragon_Knight_minimap_icon.png": 97122,
	"./map_icons/heroes/Drow_Ranger_minimap_icon.png": 10365,
	"./map_icons/heroes/Earth_Spirit_minimap_icon.png": 51167,
	"./map_icons/heroes/Earthshaker_minimap_icon.png": 36258,
	"./map_icons/heroes/Elder_Titan_minimap_icon.png": 73048,
	"./map_icons/heroes/Ember_Spirit_minimap_icon.png": 5556,
	"./map_icons/heroes/Enchantress_minimap_icon.png": 39708,
	"./map_icons/heroes/Enigma_minimap_icon.png": 71581,
	"./map_icons/heroes/Faceless_Void_minimap_icon.png": 25280,
	"./map_icons/heroes/Grimstroke_minimap_icon.png": 75896,
	"./map_icons/heroes/Gyrocopter_minimap_icon.png": 81792,
	"./map_icons/heroes/Hoodwink_minimap_icon.png": 75556,
	"./map_icons/heroes/Huskar_minimap_icon.png": 22259,
	"./map_icons/heroes/Invoker_minimap_icon.png": 55554,
	"./map_icons/heroes/Io_minimap_icon.png": 87006,
	"./map_icons/heroes/Jakiro_minimap_icon.png": 33419,
	"./map_icons/heroes/Juggernaut_minimap_icon.png": 76300,
	"./map_icons/heroes/Keeper_of_the_Light_minimap_icon.png": 27238,
	"./map_icons/heroes/Kunkka_minimap_icon.png": 7775,
	"./map_icons/heroes/Legion_Commander_minimap_icon.png": 59253,
	"./map_icons/heroes/Leshrac_minimap_icon.png": 52699,
	"./map_icons/heroes/Lich_minimap_icon.png": 4135,
	"./map_icons/heroes/Lifestealer_minimap_icon.png": 22355,
	"./map_icons/heroes/Lina_minimap_icon.png": 53476,
	"./map_icons/heroes/Lion_minimap_icon.png": 43069,
	"./map_icons/heroes/Lone_Druid_minimap_icon.png": 33605,
	"./map_icons/heroes/Luna_minimap_icon.png": 1431,
	"./map_icons/heroes/Lycan_minimap_icon.png": 35280,
	"./map_icons/heroes/Magnus_minimap_icon.png": 38534,
	"./map_icons/heroes/Marci_minimap_icon.png": 68546,
	"./map_icons/heroes/Mars_minimap_icon.png": 78571,
	"./map_icons/heroes/Medusa_minimap_icon.png": 22915,
	"./map_icons/heroes/Meepo_minimap_icon.png": 46832,
	"./map_icons/heroes/Mirana_minimap_icon.png": 27626,
	"./map_icons/heroes/Monkey_King_minimap_icon.png": 59897,
	"./map_icons/heroes/Morphling_minimap_icon.png": 95334,
	"./map_icons/heroes/Naga_Siren_minimap_icon.png": 54969,
	"./map_icons/heroes/Nature's_Prophet_minimap_icon.png": 39254,
	"./map_icons/heroes/Necrophos_minimap_icon.png": 78689,
	"./map_icons/heroes/Night_Stalker_minimap_icon.png": 946,
	"./map_icons/heroes/Nyx_Assassin_minimap_icon.png": 33128,
	"./map_icons/heroes/Ogre_Magi_minimap_icon.png": 5719,
	"./map_icons/heroes/Omniknight_minimap_icon.png": 86399,
	"./map_icons/heroes/Oracle_minimap_icon.png": 37216,
	"./map_icons/heroes/Outworld_Destroyer_minimap_icon.png": 61623,
	"./map_icons/heroes/Pangolier_minimap_icon.png": 23679,
	"./map_icons/heroes/Phantom_Assassin_minimap_icon.png": 11615,
	"./map_icons/heroes/Phantom_Lancer_minimap_icon.png": 14060,
	"./map_icons/heroes/Phoenix_minimap_icon.png": 40713,
	"./map_icons/heroes/Primal_Beast_minimap_icon.png": 54637,
	"./map_icons/heroes/Puck_minimap_icon.png": 20056,
	"./map_icons/heroes/Pudge_minimap_icon.png": 39561,
	"./map_icons/heroes/Pugna_minimap_icon.png": 83077,
	"./map_icons/heroes/Queen_of_Pain_minimap_icon.png": 85802,
	"./map_icons/heroes/Razor_minimap_icon.png": 86348,
	"./map_icons/heroes/Riki_minimap_icon.png": 55944,
	"./map_icons/heroes/Rubick_minimap_icon.png": 14358,
	"./map_icons/heroes/Sand_King_minimap_icon.png": 68762,
	"./map_icons/heroes/Shadow_Demon_minimap_icon.png": 98908,
	"./map_icons/heroes/Shadow_Fiend_minimap_icon.png": 35991,
	"./map_icons/heroes/Shadow_Shaman_minimap_icon.png": 47697,
	"./map_icons/heroes/Silencer_minimap_icon.png": 65831,
	"./map_icons/heroes/Skeleton_King_minimap_icon.png": 6620,
	"./map_icons/heroes/Skywrath_Mage_minimap_icon.png": 34895,
	"./map_icons/heroes/Slardar_minimap_icon.png": 36910,
	"./map_icons/heroes/Slark_minimap_icon.png": 90735,
	"./map_icons/heroes/Snapfire_minimap_icon.png": 48311,
	"./map_icons/heroes/Sniper_minimap_icon.png": 25796,
	"./map_icons/heroes/Spectre_minimap_icon.png": 36181,
	"./map_icons/heroes/Spirit_Breaker_minimap_icon.png": 26192,
	"./map_icons/heroes/Storm_Spirit_minimap_icon.png": 63142,
	"./map_icons/heroes/Sven_minimap_icon.png": 64159,
	"./map_icons/heroes/Techies_minimap_icon.png": 21696,
	"./map_icons/heroes/Templar_Assassin_minimap_icon.png": 29562,
	"./map_icons/heroes/Terrorblade_minimap_icon.png": 67616,
	"./map_icons/heroes/Tidehunter_minimap_icon.png": 6251,
	"./map_icons/heroes/Timbersaw_minimap_icon.png": 74818,
	"./map_icons/heroes/Tinker_minimap_icon.png": 10041,
	"./map_icons/heroes/Tiny_minimap_icon.png": 97474,
	"./map_icons/heroes/Treant_Protector_minimap_icon.png": 71618,
	"./map_icons/heroes/Troll_Warlord_minimap_icon.png": 79230,
	"./map_icons/heroes/Tusk_minimap_icon.png": 17935,
	"./map_icons/heroes/Underlord_minimap_icon.png": 46495,
	"./map_icons/heroes/Undying_minimap_icon.png": 37588,
	"./map_icons/heroes/Ursa_minimap_icon.png": 96584,
	"./map_icons/heroes/Vengeful_Spirit_minimap_icon.png": 22195,
	"./map_icons/heroes/Venomancer_minimap_icon.png": 88308,
	"./map_icons/heroes/Viper_minimap_icon.png": 42506,
	"./map_icons/heroes/Visage_minimap_icon.png": 82913,
	"./map_icons/heroes/Void_Spirit_minimap_icon.png": 15327,
	"./map_icons/heroes/Warlock_minimap_icon.png": 61222,
	"./map_icons/heroes/Weaver_minimap_icon.png": 45819,
	"./map_icons/heroes/Windranger_minimap_icon.png": 67456,
	"./map_icons/heroes/Winter_Wyvern_minimap_icon.png": 25714,
	"./map_icons/heroes/Witch_Doctor_minimap_icon.png": 20357,
	"./map_icons/heroes/Wraith_King_minimap_icon.png": 88096,
	"./map_icons/heroes/Zeus_minimap_icon.png": 58517,
	"./map_icons/map_img.png": 52494,
	"./rank_icons/SeasonalRank0-0.png": 63874,
	"./rank_icons/SeasonalRank1-0.png": 19105,
	"./rank_icons/SeasonalRank1-1.png": 78122,
	"./rank_icons/SeasonalRank1-2.png": 15965,
	"./rank_icons/SeasonalRank1-3.png": 87359,
	"./rank_icons/SeasonalRank1-4.png": 17677,
	"./rank_icons/SeasonalRank1-5.png": 9293,
	"./rank_icons/SeasonalRank2-0.png": 7913,
	"./rank_icons/SeasonalRank2-1.png": 46633,
	"./rank_icons/SeasonalRank2-2.png": 35439,
	"./rank_icons/SeasonalRank2-3.png": 75308,
	"./rank_icons/SeasonalRank2-4.png": 10541,
	"./rank_icons/SeasonalRank2-5.png": 77688,
	"./rank_icons/SeasonalRank3-0.png": 44111,
	"./rank_icons/SeasonalRank3-1.png": 64576,
	"./rank_icons/SeasonalRank3-2.png": 95371,
	"./rank_icons/SeasonalRank3-3.png": 96609,
	"./rank_icons/SeasonalRank3-4.png": 83107,
	"./rank_icons/SeasonalRank3-5.png": 80976,
	"./rank_icons/SeasonalRank4-0.png": 31719,
	"./rank_icons/SeasonalRank4-1.png": 68888,
	"./rank_icons/SeasonalRank4-2.png": 69695,
	"./rank_icons/SeasonalRank4-3.png": 82663,
	"./rank_icons/SeasonalRank4-4.png": 53159,
	"./rank_icons/SeasonalRank4-5.png": 65996,
	"./rank_icons/SeasonalRank5-0.png": 11237,
	"./rank_icons/SeasonalRank5-1.png": 41151,
	"./rank_icons/SeasonalRank5-2.png": 85772,
	"./rank_icons/SeasonalRank5-3.png": 2468,
	"./rank_icons/SeasonalRank5-4.png": 95591,
	"./rank_icons/SeasonalRank5-5.png": 11370,
	"./rank_icons/SeasonalRank6-0.png": 12112,
	"./rank_icons/SeasonalRank6-1.png": 90844,
	"./rank_icons/SeasonalRank6-2.png": 17039,
	"./rank_icons/SeasonalRank6-3.png": 51286,
	"./rank_icons/SeasonalRank6-4.png": 21515,
	"./rank_icons/SeasonalRank6-5.png": 95100,
	"./rank_icons/SeasonalRank7-0.png": 86152,
	"./rank_icons/SeasonalRank7-1.png": 66112,
	"./rank_icons/SeasonalRank7-2.png": 64707,
	"./rank_icons/SeasonalRank7-3.png": 52764,
	"./rank_icons/SeasonalRank7-4.png": 17520,
	"./rank_icons/SeasonalRank7-5.png": 25643,
	"./rank_icons/SeasonalRank8-0.png": 98803,
	"./rank_icons/SeasonalRank8-1.png": 1768,
	"./rank_icons/SeasonalRankTop1.png": 93492,
	"./rank_icons/SeasonalRankTop2.png": 84681,
	"./rank_icons/SeasonalRankTop3.png": 15532,
	"./rank_icons/SeasonalRankTop4.png": 37232,
	"./team_icons/dire_icon.png": 3857,
	"./team_icons/radiant_icon.png": 26288
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40650;